import { createRicosFunctionalExtension } from './../../tiptap-extensions';

import type { ResultContent } from '../types';
import { insertAiGeneratedContent } from './insert-ai-generated-content';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    ai: {
      insertAiGeneratedContent: (
        value: ResultContent,
        options?: { position?: 'before' | 'after' | 'replace' }
      ) => ReturnType;
    };
  }
}

export const tiptapExtensions = [
  createRicosFunctionalExtension({
    name: 'ai-commands',
    type: 'extension',
    groups: [],
    createExtensionConfig: () => ({
      name: 'ai-commands',
      addCommands() {
        return {
          insertAiGeneratedContent,
        };
      },
    }),
  }),
];
